import { TRADE_HISTORY_TABS } from "../../constants";
import TradeOrderFilter from "./TradeOrderFilter";
import { useSearchParams } from "react-router-dom";
import TradeFilter from "./TradeFilter";

function TradeHistoryFilters() {
  const [searchParams] = useSearchParams();
  const tradeTab = +searchParams.get("tradeTab") || 0;

  return (
    <>
      {tradeTab === TRADE_HISTORY_TABS.tradeHistory.value ? (
        <TradeFilter />
      ) : (
        <TradeOrderFilter />
      )}
    </>
  );
}

export default TradeHistoryFilters;
